import React from "react";
import { Drafts, Inbox, Sent, Signed } from "../img";
import { Typography } from "@material-ui/core";

const EmptyTable = ({ title, src }) => {
  let info;
  switch (src) {
    case "inbox":
      src = Inbox;
      info = "Aquí se mostrarán los oficios recibidos.";
      break;
    case "draft":
      src = Drafts;
      info = "Los oficios en edición que no han sido enviados aparecerán aquí.";
      break;
    case "sent":
      src = Sent;
      info = "Los oficios que han sido enviados aparecerán aquí.";
      break;
    case "pending":
      src = Signed;
      info = "Aquí aparecerán los oficios que usted ha enviado para solicitar firma.";
      break;
    case "review":
      src = Signed;
      info =
        "Los oficios que requieren de su firma para ser enviados aparecerán aquí.";
      break;
      case "pass":
        src = Signed;
        info =
          "Los oficios que requieren de su revisión para ser enviados aparecerán aquí.";
        break;
      case "approve":
        src = Signed;
        info =
          "Los oficios que se envíen para ser revisados aparecerán aquí.";
      break;
      case "physical":
        src = Signed;
        info =
          "Los oficios que se soliciten en físico aparecerán aquí.";
      break;
    default:
      break;
  }

  return (
    <div style={{ textAlign: "center" }}>
      <Typography variant={"h6"} style={{ color: "#888883", margin: ".5em" }}>
        {src === "all" ? (
          <span>
            No se encontraron resultados que coincidan con su <b>búsqueda</b>.
          </span>
        ) : (
          <div>
            <img alt={"category"} src={src} style={{width: '149px'}}/>
            <br />
            <span>
              No hay nada en <b> {title} </b>
            </span>
          </div>
        )}
      </Typography>
      <Typography variant={"subtitle1"} style={{ color: "#888883" }}>
        {info}
      </Typography>
    </div>
  );
};

export default EmptyTable;



// WEBPACK FOOTER //
// ./src/components/EmptyTable.js